export default { 
  name : 'Parent Device ESN',
  objectType : 'boat',
  valueType : 'string',
  displayName : 'Parent Device ESN',
  get : () => null
}
